import { TransactionMethod } from '@cpce/database/enums';
import z from 'zod';
export const TransactionMethodSchema = z.enum(TransactionMethod);
export const TRANSACTION_METHOD_LABELS = {
    [TransactionMethod.bankTransfer]: 'Virement',
    [TransactionMethod.bankCard]: 'Carte bancaire',
    [TransactionMethod.check]: 'Chèque',
    [TransactionMethod.cash]: 'Espèces',
    [TransactionMethod.directDebit]: 'Prélèvement',
    [TransactionMethod.ANCV]: 'ANCV',
};
export const TRANSACTION_METHOD_OPTIONS = [
    {
        value: TransactionMethod.bankTransfer,
        label: TRANSACTION_METHOD_LABELS[TransactionMethod.bankTransfer],
    },
    {
        value: TransactionMethod.bankCard,
        label: TRANSACTION_METHOD_LABELS[TransactionMethod.bankCard],
    },
    { value: TransactionMethod.check, label: TRANSACTION_METHOD_LABELS[TransactionMethod.check] },
    { value: TransactionMethod.cash, label: TRANSACTION_METHOD_LABELS[TransactionMethod.cash] },
    {
        value: TransactionMethod.directDebit,
        label: TRANSACTION_METHOD_LABELS[TransactionMethod.directDebit],
    },
    { value: TransactionMethod.ANCV, label: TRANSACTION_METHOD_LABELS[TransactionMethod.ANCV] },
];
